import Vue from 'vue'
var filter = {
    getDate: function (date) {
        if (typeof date === "string") {
            var mts = date.match(/(\/Date\((\d+)\)\/)/);
            if (mts && mts.length >= 3) {
                date = parseInt(mts[2]);
            }
        }
        date = new Date(date);
        return date;
    },
    dateTimeFormat: function (date, format) {
        //时间格式化 <p>{{'/Date(1493027950023)/' | dateTimeFormat('yyyy/MM/dd hh:mm:ss')}}</p>

        if (typeof date == "string") {
            date = date.replace(/-/g, "/").replace("T", " ");
        }
        date = filter.getDate(date);
        if (!date || date.toUTCString() == "Invalid Date") {
            return "";
        }
        var map = {
            "M": date.getMonth() + 1,                       //月份
            "d": date.getDate(),                            //日
            "h": date.getHours(),                           //小时
            "m": date.getMinutes(),                         //分
            "s": date.getSeconds(),                         //秒
            "q": Math.floor((date.getMonth() + 3) / 3),     //季度
            "S": date.getMilliseconds()                     //毫秒
        };
        format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
            var v = map[t];

            if (v !== undefined) {
                if (all.length > 1) {
                    v = '0' + v;
                    v = v.substr(v.length - 2);
                }
                return v;
            } else if (t === 'y') {
                return (date.getFullYear() + '').substr(4 - all.length);
            }
            return all;
        });
        return format;

    },
    handleMoney: function (num) {
        if(!num){return 0}
        // 首先先声明一个金额单位数组
        let AmountUnitlist = ["元", "万", "亿", "兆", '京', '垓', '杼']
        // 将数字金额转为字符串
        let strnum = num.toString()
        // 声明一个变量用于接收金额单位
        let AmountUnit = ''
        // 循环遍历单位数组
        AmountUnitlist.find((item, index) => {
            let newNum = ''
            // 判断一下传进来的金额是否包含小数点
            if (strnum.indexOf('.') !== -1) {
                // 若有则将小数点前的字符截取出来
                newNum = strnum.substring(0, strnum.indexOf('.'))
            } else {
                // 没有则直接等于原金额
                newNum = strnum
            }
            // 判断一下经过小数点截取后的金额字符长度是否小于5
            if (newNum.length < 5) {
                // 若小于5则接收当前单位，并跳出迭代
                AmountUnit = item
                return true
            } else {
                // 若不小于5则将经过小数点截取处理过后的字符除以10000后作为下一轮迭代的初始金额重新判断(每一个单位之间相距4位数，故除以10000)
                strnum = (newNum * 1 / 10000).toString()
            }
        })
        let money = {num: 0, unit: ""}
        // 保留2位小数
        money.num = (strnum * 1).toFixed(2)
        // 接收单位
        money.unit = AmountUnit
        return Number(money.num)
    },
    handleUnit: function (num) {
        if(!num){return '元'}
        // 首先先声明一个金额单位数组
        let AmountUnitlist = ["元", "万", "亿", "兆", '京', '垓', '杼']
        // 将数字金额转为字符串
        let strnum = num.toString()
        // 声明一个变量用于接收金额单位
        let AmountUnit = ''
        // 循环遍历单位数组
        AmountUnitlist.find((item, index) => {
            let newNum = ''
            // 判断一下传进来的金额是否包含小数点
            if (strnum.indexOf('.') !== -1) {
                // 若有则将小数点前的字符截取出来
                newNum = strnum.substring(0, strnum.indexOf('.'))
            } else {
                // 没有则直接等于原金额
                newNum = strnum
            }
            // 判断一下经过小数点截取后的金额字符长度是否小于5
            if (newNum.length < 5) {
                // 若小于5则接收当前单位，并跳出迭代
                AmountUnit = item
                return true
            } else {
                // 若不小于5则将经过小数点截取处理过后的字符除以10000后作为下一轮迭代的初始金额重新判断(每一个单位之间相距4位数，故除以10000)
                strnum = (newNum * 1 / 10000).toString()
            }
        })
        let money = {unit: ""}
        // 接收单位
        money.unit = AmountUnit
        return money.unit
    }
}
for (var filterItem in filter) {
    Vue.filter(filterItem, filter[filterItem])
}
